export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.overview': '总览',
  'menu.fund': '基金',
  'menu.fund.list': '基金列表',
  'menu.fund.formation': '新设审批',
  'menu.organizations': '主体档案',
  'menu.fund.formationDetail': '新设详情',
  'menu.fund.detail': '基金详情',
  'menu.fundraising': '募资跟进',
  'menu.fundraising.board': '募资看板',
  'menu.fundraising.opportunities': '出资人跟进',
  'menu.fundraising.opportunityDetail': '跟进详情',
  'menu.lpAndContact': '出资人档案',
  'menu.lpAndContact.lp': '出资人机构',
  'menu.lpAndContact.contact': '联系人',
  'menu.lpAndContact.lpDetail': '出资人详情',
  'menu.lpAndContact.contactDetail': '联系人详情',
  'menu.contribution': '缴款与到账',
  'menu.contributionDetail': '出资详情',
  'menu.setting': '设置',
  'menu.setting.dictionary': '业务字典',
  'menu.setting.permissions': '权限管理',
  'menu.setting.modelSettings': '模型设置',
  'menu.login': '登录',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.logout': '退出登录',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
